import React from 'react';
import iconNames from './icon-names';

export type IconName = typeof iconNames[number];

type IconPaths = {
  [key in IconName]: {
    path: React.ReactElement<SVGPathElement>;
    viewBox?: string;
  };
};

const iconPaths: IconPaths = {
  smiley: {
    path: (
      <path
        fill="currentColor"
        d="M20.523 20.523C21.774 19.276 22.4 17.768 22.4 16c0-1.773-.626-3.283-1.877-4.53C19.276 10.223 17.768 9.6 16 9.6c-1.773 0-3.283.623-4.53 1.87-.555.555-.986 1.162-1.294 1.82-.123.263-.227.533-.313.811C9.688 14.697 9.6 15.33 9.6 16c0 1.768.623 3.276 1.87 4.523.365.366.752.68 1.16.938.993.626 2.116.939 3.37.939 1.25 0 2.37-.313 3.356-.939.413-.259.801-.572 1.167-.938zM16 10.353c1.559 0 2.887.552 3.985 1.655 1.103 1.098 1.654 2.429 1.654 3.992 0 1.559-.551 2.887-1.654 3.985-1.098 1.103-2.426 1.654-3.985 1.654-1.563 0-2.894-.551-3.992-1.654-1.103-1.098-1.654-2.426-1.654-3.985 0-.701.11-1.355.33-1.963.107-.29.237-.57.39-.838.25-.424.562-.82.934-1.191 1.098-1.103 2.429-1.654 3.992-1.654zm-1.849 9.31c.612.374 1.228.554 1.849.54.621.014 1.235-.166 1.842-.54 1.057-.707 1.635-1.63 1.735-2.767.01-.194-.254-.284-.427-.185 0 0-.803 1.158-3.15 1.158-1.934 0-3.15-1.158-3.15-1.158-.265-.13-.432-.01-.427.185.11 1.147.685 2.07 1.728 2.766zm.683-4.31l.256.37c.142.175.213.085.213-.27.005-.489-.085-.892-.27-1.21-.213-.331-.446-.495-.697-.49h-.007c-.256-.005-.49.159-.704.49-.185.318-.275.721-.27 1.21 0 .355.07.445.213.27l.256-.37c.128-.213.296-.308.505-.285h.007c.204-.023.37.072.498.285zm1.863.1c0 .355.069.445.206.27l.256-.37c.133-.213.301-.308.505-.285h.007c.204-.023.372.072.505.285l.249.37c.142.175.213.085.213-.27.005-.489-.085-.892-.27-1.21-.209-.331-.44-.495-.697-.49h-.007c-.256-.005-.488.159-.697.49-.185.318-.275.721-.27 1.21z"
      />
    ),
    viewBox: '9 9 14 14',
  },
  close: {
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.527 2.213l-1.74-1.74L7 5.259 2.213.473l-1.74 1.74L5.259 7 .473 11.787l1.74 1.74L7 8.741l4.787 4.786 1.74-1.74L8.741 7l4.786-4.787z"
        fill="currentColor"
      />
    ),
    viewBox: '0 0 14 14',
  },
  muted: {
    path: (
      <path
        d="M10.044 57a1.44 1.44 0 001.435-1.436H8.608c0 .79.646 1.436 1.436 1.436zm3.723-2.154H4.3v-.718l1.436-1.436v-3.59c0-.695.117-1.355.34-1.946l-1.489-1.49 1.016-1.015L16.77 55.82l-1.015 1.015-1.99-1.989zm-5.834-9.885c.314-.173.66-.307 1.034-.396v-.488c0-.596.48-1.077 1.077-1.077.595 0 1.077.481 1.077 1.077v.488c2.06.488 3.23 2.333 3.23 4.538v2.277l-6.418-6.42z"
        fill="currentColor"
        fillRule="nonzero"
      />
    ),
    viewBox: '2 42 16 16',
  },
  external: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16667 11.5556H10.8333C11.2306 11.5556 11.5556 11.2306 11.5556 10.8333V8.22222C11.5556 7.825 11.8806 7.5 12.2778 7.5C12.675 7.5 13 7.825 13 8.22222V11.5556C13 12.35 12.35 13 11.5556 13H1.44444C0.65 13 0 12.35 0 11.5556V1.44444C0 0.65 0.642778 0 1.44444 0H4.77778C5.175 0 5.5 0.325 5.5 0.722222C5.5 1.11944 5.175 1.44444 4.77778 1.44444H2.16667C1.76944 1.44444 1.44444 1.76944 1.44444 2.16667V10.8333C1.44444 11.2306 1.76944 11.5556 2.16667 11.5556ZM8.66667 1.44444C8.26944 1.44444 7.94444 1.11944 7.94444 0.722222C7.94444 0.325 8.26944 0 8.66667 0H12.2778C12.675 0 13 0.325 13 0.722222V4.33333C13 4.73056 12.675 5.05556 12.2778 5.05556C11.8806 5.05556 11.5556 4.73056 11.5556 4.33333V2.46278L4.96167 9.05667C4.68 9.33833 4.225 9.33833 3.94333 9.05667C3.66167 8.775 3.66167 8.32 3.94333 8.03833L10.5372 1.44444H8.66667Z"
      />
    ),
    viewBox: '0 0 13 13',
  },
  camera: {
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.017 4.444h2.354c.818 0 1.486.65 1.486 1.445v8.667c0 .794-.668 1.444-1.486 1.444H7.486C6.669 16 6 15.35 6 14.556V5.889c0-.795.669-1.445 1.486-1.445H9.84l.913-.975a1.53 1.53 0 011.1-.469h3.15c.415 0 .817.173 1.091.47l.922.974zm-7.303 5.778c0 1.994 1.664 3.611 3.715 3.611 2.05 0 3.714-1.617 3.714-3.61 0-1.994-1.664-3.612-3.714-3.612S9.714 8.23 9.714 10.222z"
          fill="currentColor"
        />
        <ellipse
          cx="13.428"
          cy="10.222"
          rx="2.229"
          ry="2.167"
          fill="currentColor"
        />
      </>
    ),
    viewBox: '6 2 15 15',
  },
  edit: {
    path: (
      <path
        d="M.952 9.246v2.543h2.546l7.37-7.43-2.546-2.542-7.37 7.429zm11.587-6.91a.557.557 0 000-.808L11.214.202a.557.557 0 00-.808 0L9.37 1.24l2.19 2.19.98-1.095z"
        fill="currentColor"
        fillRule="evenodd"
      />
    ),
    viewBox: '0 0 13 13',
  },
  profile: {
    path: (
      <>
        <circle cx="10" cy="10" r="8.75" stroke="currentColor" />
        <circle
          r="2.859"
          transform="matrix(1 0 0 -1 10 8.724)"
          stroke="currentColor"
        />
        <path
          d="M15.223 16.806a5.223 5.223 0 10-10.446 0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
    viewBox: '0 0 20 20',
  },
  bell: {
    path: (
      <>
        <path
          d="M15.205 13.82H2.485c.583 0 .912-.305 1.1-.81.904-2.44-1.506-9.554 5.26-9.554s4.355 7.113 5.26 9.554c.188.505.517.81 1.1.81z"
          stroke="currentColor"
        />
        <path
          d="M16.436 15.052c0 .68-.551 1.231-1.231 1.231H2.485a1.228 1.228 0 01-1.232-1.231c0-.68.552-1.232 1.232-1.232h12.72a1.228 1.228 0 011.231 1.232v0z"
          stroke="currentColor"
        />
        <path
          d="M11.308 16.283a2.464 2.464 0 01-2.463 2.464 2.463 2.463 0 01-2.463-2.464h4.926z"
          stroke="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.845.753c-.97 0-1.756.786-1.756 1.756a386.886 386.886 0 00.002.872l.001.122v.005a1.298 1.298 0 00.05.348c.104-.332.464-.608.948-.751a181.359 181.359 0 010-.596.755.755 0 111.51 0 382.612 382.612 0 010 .596c.484.143.843.42.948.75a1.465 1.465 0 00.05-.347V3.38a136.103 136.103 0 00.002-.872c0-.97-.786-1.756-1.755-1.756z"
          fill="currentColor"
        />
      </>
    ),
    viewBox: '0 0 17 20',
  },
  eye: {
    path: (
      <>
        <path
          d="M1 7s3.624-6 9-6c5.376 0 9.03 6 9.03 6M1 7s3.624 6 9 6c5.376 0 9.03-6 9.03-6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="10.014" cy="7" r="2.988" stroke="currentColor" />
      </>
    ),
    viewBox: '0 0 20 14',
  },
};

export default iconPaths;
